module.exports = __webpack_public_path__ + "84c7baf0945d0c965739df153af7feee.svg";